import {
    takeLatest, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import { waitAuthorizedCheck } from './Auth';
import * as Actions from '../actions/ViewerManagement';

function* getListEventViewerManagement(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload.event_name}/viewer/`;
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
                body: {
                    page: action.payload.page,
                    page_size: action.payload.page_size,
                },
            },
        );
        yield put(Actions.GetListEventOfViewerRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetListEventOfViewerRequestedReceivedFailure(yield error));
    }
}
function* updateStatusViewer(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        let endpoint = '';
        if (action.payload.type === 1) {
            endpoint = '/api/v1/user/approve_register/';
        } else {
            endpoint = '/api/v1/user/reject_register/';
        }
        const response = yield call(
            API.post, {
                endpoint: `${endpoint}`,
                body: {
                    user_id: action.payload.user_id,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.UpdateStatusViewerRequestedReceived(response));
    } catch (error) {
        yield put(Actions.UpdateStatusViewerRequestedReceivedFailure(yield error));
    }
}

function* getCsvViewer(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.shortName}/download-csv-viewer/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetCsvViewerRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetCsvViewerReceiveFailure(yield error));
    }
}

export default function* login() {
    yield all([
        takeLatest('GET_LIST_EVENT_OF_VIEWER_REQUESTED', getListEventViewerManagement),
        takeLatest('UPDATE_STATUS_VIEWER_REQUESTED', updateStatusViewer),
        takeLatest('GET_CSV_VIEWER_REQUESTED', getCsvViewer),
    ]);
}
